/**
 * @file input
 */
import InputNumber from 'antd/es/input-number';
export { InputNumber };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSW5wdXROdW1iZXIvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxXQUFpQyxNQUFNLHNCQUFzQixDQUFBO0FBRXBFLE9BQU8sRUFBRSxXQUFXLEVBQUUsQ0FBQSJ9